// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__dSyrP","btn__primary":"button_btn__primary__7CxMt","btn__secondary":"button_btn__secondary__GHD8R"};